// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.chip--small[data-v-e20ddc98] {\n  height: 22px;\n}\n", ""]);
// Exports
module.exports = exports;
